import { render, staticRenderFns } from "./SimuladorRuta.vue?vue&type=template&id=04e23e96&scoped=true"
import script from "./SimuladorRuta.vue?vue&type=script&lang=js"
export * from "./SimuladorRuta.vue?vue&type=script&lang=js"
import style0 from "./SimuladorRuta.vue?vue&type=style&index=0&id=04e23e96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e23e96",
  null
  
)

export default component.exports